import {
  createUser,
  editUser,
  createHousehold,
  unassignHousehold,
  assingHousehold,
} from './mockCreateUserApi'
import {
  assignUser,
  assingTags,
  unassignTag,
  unassignFamilyRelation,
} from './mockUsersApi'

export const saveFullUser = async (
  form: any,
  communityId: number,
  options?: {
    originalHousehold?: any
    oldFamilyRelationIds?: number[]
    oldTagRelation?: any[]
  }
): Promise<number> => {
  const { originalHousehold, oldFamilyRelationIds = [], oldTagRelation = [] } = options ?? {}

  // Create or update user
  let userId: number
  try {
    if (form.id && form.id !== 0) {
      const res = await editUser(form, communityId)
      userId = res.data.user.userId
    } else {
      const res = await createUser(form, communityId)
      userId = res.data.user.userId
    }
 
    // Household
    if (form.family?.household?.firstName) {
      if (!form.family.household.id) {
        await createHousehold(userId, form.family.household, communityId)
      } else if (form.family.household.firstName !== originalHousehold?.firstName) {
        await unassignHousehold(userId, communityId)
        await createHousehold(userId, form.family.household, communityId)
      }
    }

    // Unassign old family relations
    for (const relationId of oldFamilyRelationIds) {
      await unassignFamilyRelation({ relationId, communityId })
    }

    // Children
    for (const child of form.family?.children ?? []) {
      if (child.mode === 'select') {
        if (child.id && child.id !== 0) {
          await assignUser({ userId, communityId, relatedUserId: child.id, relationTypeId: 2 })
        }
      } else if (child.mode === 'new' && child.firstName?.trim()) {
        const res = await createUser({ population: child }, communityId)
        await assignUser({ userId, communityId, relatedUserId: res.data.user.userId, relationTypeId: 2 })
      }
    }

    // Spouse
    if (form.family?.spouse) {
      const spouse = form.family.spouse
      if (spouse.mode === 'select') {
        if (spouse.id && spouse.id > 0) {
          await assignUser({ userId, communityId, relatedUserId: spouse.id, relationTypeId: 3 })
        }
      } else if (spouse.mode === 'new' && spouse.firstName?.trim()) {
        const res = await createUser({ population: spouse }, communityId)
        await assignUser({ userId, communityId, relatedUserId: res.data.user.userId, relationTypeId: 3 })
      }
    }

    // Unassign old tags
    for (const tag of oldTagRelation) {
      await unassignTag({ userId, communityId, tag: tag.tag, tagTypeId: tag.tagTypeId })
    }

    // Save tags
    for (const userType of form.population?.userTypes ?? []) {
      await assingTags({ userId, communityId, tag: userType.tagName, tagTypeId: userType.tagTypeId })
    }
    for (const role of form.contacts?.roles ?? []) {
      await assingTags({ userId, communityId, tag: role.tagName, tagTypeId: role.tagTypeId })
    }
    for (const tag of form.contacts?.tags ?? []) {
      await assingTags({ userId, communityId, tag: tag.tagName, tagTypeId: tag.tagTypeId })
    }
  } catch (e) {
    throw new Error('שגיאה בשמירה')
  }

  return userId
}
